// Vendor
import * as React from 'react';
import { SPOT_GREY_7 } from '@thredup/styleguide/src/variables/colors';

export interface LogoProps {
  className?: string;
  fill?: string;
  height?: number;
  id?: string;
  width?: number;
}

/**
 * @name Logo
 * @description thredUP Logo
 */
const Logo: React.FC<LogoProps> = (props) => {
  const { className, fill, height, id, width } = props;

  return (
    <svg
      aria-labelledby={id}
      className={className}
      fill={fill}
      height={height}
      role="img"
      viewBox="0 0 290 66"
      width={width}
    >
      <title id={id}>thredUP Logo</title>
      <desc>thredUP | The Largest Online Consignment & Thrift Store</desc>
      <g>
        <path
          d="M30.2,19.1H1.1c-0.6,0-1.1,0.5-1.1,1.1V27c0,0.6,0.4,1,1,1c0,0,0.1,0,
            0.1,0h9.2c0.5,0,1,0.3,1,0.8c0,0,0,0,0,0.1V65 c0,0.6,0.5,1.1,1.1,
            1.1h6.8c0.6,0,1.1-0.5,1.1-1.1V29c0-0.5,0.4-0.9,0.9-1h9.3c0.6,0,
            1.1-0.5,1.1-1.1v-6.8C31.4,19.5,30.8,19.1,30.2,19.1L30.2,19.1z"
          fill={fill}
        />
        <path
          d="M73.5,19.1h-6.8c-0.6,0-1.1,0.5-1.1,1.1v17c0,0.5-0.4,0.9-0.9,1H54.3c
            -0.5,0-1-0.3-1-0.8c0,0,0,0,0-0.1V20.2c0-0.6-0.5-1.1-1.1-1.1h-6.7c
            -0.6,0-1.1,0.5-1.1,1.1V65c0,0.6,0.5,1.1,1.1,1.1H52c0.6,0,1.4-0.5,1.4
            -1.1V48c0-0.5,0.3-1,0.8-1c0,0,0,0,0.1,0h10.4c0.5,0,0.9,0.4,1,
            0.9V65c0,0.6,0.5,1.1,1.1,1.1h6.8c0.6,0,1.1-0.5,1.1-1.1V20.2C74.6,
            19.6,74.1,19.1,73.5,19.1z"
          fill={fill}
        />
        <path
          d="M118.7,33.1c0-7.7-6.3-14-14-14H89.9c-0.6,0-1.1,0.5-1.1,1.1V65c0,
            0.6,0.5,1.1,1.1,1.1h6.8c0.6,0,1.1-0.5,1.1-1.1V48
            c0-0.5,0.3-1,0.8-1c0,0,0,0,0.1,0h1.9c0.7,0,1.3,0.4,1.5,1.1l6.9,
            16.8c0.2,0.7,0.9,1.2,1.7,1.2h7c0.4,0.1,0.8-0.1,1-0.5
            c0.2-0.4,0.2-0.8,0-1.2l-7.3-17c-0.5-1.1-0.6-1.8,0.5-2.6C116.7,
            41.6,118.7,38,118.7,33.1z M104.7,38.1h-6.1c-0.5,0-1-0.3-1-0.8
            c0,0,0,0,0-0.1V29c0-0.5,0.4-0.9,0.9-1h6.2c2.7,0,5,2.3,5,5c0.1,2.7-2,
            5-4.7,5.1C104.9,38.1,104.8,38.1,104.7,38.1L104.7,38.1z"
          fill={fill}
        />
        <path
          d="M157,57.1h-16c-0.5,0-1-0.3-1-0.8c0,0,0,0,0-0.1V48c0-0.5,0.3-1,
            0.8-1c0,0,0,0,0.1,0h11.8c0.6,0,1.1-0.5,1.1-1.1v-6.8
            c0-0.6-0.5-1.1-1.1-1.1H141c-0.5,0-1-0.3-1-0.8c0,0,0,0,
            0-0.1v-8.2c0-0.5,0.4-0.9,0.9-1H157c0.6,0,1.1-0.5,1.1-1.1V20
            c0-0.6-0.5-1.1-1.1-1.1h-24.9c-0.6,0-1.1,0.5-1.1,1.1v44.8c0,
            0.6,0.5,1.1,1.1,1.1H157c0.6,0,1.1-0.5,1.1-1.1V58
            C158,57.5,157.5,57.1,157,57.1z"
          fill={fill}
        />
        <path
          d="M186.7,19.1h-14.3c-0.6,0-1.1,0.5-1.1,1.1V65c0,0.6,0.5,1.1,
            1.1,1.1h14.3c7.7,0,13.8-6.1,14.8-14.7
            c0.7-5.8,0.7-11.6,0-17.4C200.5,25.2,194.4,19.1,186.7,
            19.1z M192.5,51.4c-0.4,3.4-2.8,5.8-5.9,5.8h-5.4c-0.5,0-1-0.3-1-0.8
            c0,0,0,0,0-0.1V29c0-0.5,0.4-0.9,0.9-1h5.5c3.1,0,5.5,2.4,5.9,
            5.8C193.2,39.6,193.2,45.5,192.5,51.4z"
          fill={fill}
        />
        <path
          d="M244.8,0.1H238c-0.6,0-1.1,0.5-1.1,1.1v31.9c0,3.4-2.8,
            5.7-6.9,5.7s-6.8-2.4-6.8-5.7V1.2c0-0.6-0.5-1.1-1.1-1.1h-6.9
            c-0.6,0-1.1,0.5-1.1,1.1v31.9c0,8.2,6.9,14.7,15.7,14.7s15.9-6.5,
            15.9-14.7V1.2c0.1-0.5-0.1-0.9-0.6-1.1
            C245,0.1,244.9,0.1,244.8,0.1z"
          fill={fill}
        />
        <path
          d="M275.2,0.1h-14.9c-0.6,0-1.1,0.5-1.1,1.1V46c0,0.6,0.5,1.1,1.1,
            1.1h6.8c0.6,0,1.1-0.5,1.1-1.1V29c0-0.5,0.3-1,0.8-1c0,0,0,0,0.1,
            0h6.2c7.7,0.6,14.5-5.1,15.1-12.8s-5.1-14.5-12.8-15.1C276.8,0,276,0,
            275.2,0.1L275.2,0.1z M275.2,19.1h-6.1c-0.5,0-1-0.3-1-0.8c0,0,0,0,
            0-0.1V10c0-0.5,0.3-1,0.8-1c0,0,0,0,0.1,0h6.2c2.7,0.1,4.9,2.3,5,
            5C280.2,16.8,278,19,275.2,19.1L275.2,19.1z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

Logo.defaultProps = {
  fill: SPOT_GREY_7,
  height: 60,
  id: 'thredup-Logo-icon',
  width: 145
};

export { Logo };
